import {createApp} from 'vue'

import ContactUs from './ContactUs.vue'
import axios from "axios";


let initApp = () => {
  axios.get('/assets/config/config.json').then(res => {

    const app = createApp(ContactUs);

    app.provide('$config', res.data);

    app.mount('#contact-us');
  });


  // axios.get('/assets/config/config.json').then(res => {
  //   Vue.prototype.$config = res.data;
  //
  //   new Vue({
  //     render: h => h(ContactUs),
  //   }).$mount('#contact-us')
  // });
}

initApp();
